/**
 * Bundle row field validation + prop resolution (extracted from pb-logic-offers.liquid — PB-FND-20).
 * Patches window.productBuilder after pb-logic-core loads.
 */
(function (global) {
  'use strict';

  function patchProductBuilder(optionalPb) {
    var pb = optionalPb || global.productBuilder;
    if (!pb) return;
    Object.assign(pb, {
      normalizeBundleFieldLabel: function(s) {
          return String(s == null ? '' : s).trim().toLowerCase().replace(/\s+/g, ' ');
      },

      parseBundleFieldSettingsString: function(raw) {
          const out = {};
          const s = String(raw == null ? '' : raw).trim();
          if (!s) return out;
          if (s.charAt(0) === '{') {
              try {
                  const j = JSON.parse(s);
                  if (j && typeof j === 'object' && !Array.isArray(j)) return j;
              } catch (e) {}
          }
          s.split(/\r?\n/).forEach(line => {
              line = line.trim();
              if (!line) return;
              const idx = line.indexOf(':');
              if (idx === -1) return;
              const key = line.slice(0, idx).trim().replace(/\s+/g, '_');
              const val = line.slice(idx + 1).trim();
              if (key) out[key] = val;
          });
          return out;
      },

      parseBundleFieldSettings: function(field) {
          if (!field || field.settings == null) return {};
          if (typeof field.settings === 'object' && !Array.isArray(field.settings)) {
              const merged = { ...field.settings };
              if (field.settings.value != null && typeof field.settings.value === 'string' && field.settings.value.trim()) {
                  const nested = this.parseBundleFieldSettingsString(field.settings.value);
                  Object.assign(merged, nested);
              }
              return merged;
          }
          try {
              return JSON.parse(String(field.settings));
          } catch (e) {
              return this.parseBundleFieldSettingsString(field.settings);
          }
      },

      getAiImagePhotoKeyFromField: function(field) {
          if (!field || !field.type || String(field.type).toLowerCase().indexOf('ai image') === -1) return null;
          const st = this.parseBundleFieldSettings(field);
          return (st && st.photo_property && String(st.photo_property).trim()) || 'Photo';
      },

      getAiImageCharacterKeyFromField: function(field) {
          if (!field || !field.type || String(field.type).toLowerCase().indexOf('ai image') === -1) return null;
          const st = this.parseBundleFieldSettings(field);
          const p = st.character_property || st.characterProperty;
          if (p && String(p).trim()) return String(p).trim();
          return (field.label && String(field.label).trim()) || 'Character';
      },

      isBundleFieldRequired: function(field) {
          if (!field) return false;
          const st = this.parseBundleFieldSettings(field);
          if (st.required === true || st.required === 'true') return true;
          if (st.required === false || st.required === 'false') return false;
          let raw = '';
          if (field.settings != null) {
              if (typeof field.settings === 'string') raw = field.settings;
              else if (typeof field.settings === 'object' && field.settings.value != null) raw = String(field.settings.value);
              else raw = String(field.settings);
          }
          if (/required\s*:\s*false/i.test(raw)) return false;
          if (/required\s*:\s*true/i.test(raw)) return true;
          const type = String(field.type || '').toLowerCase();
          if (type.includes('audio') || type.includes('upload') || type.includes('ai image')) return false;
          return true;
      },

      isDesignLibraryField: function(field) {
          if (!field) return false;
          const type = String(field.type || '').toLowerCase().replace(/\s+/g, ' ');
          if (type.indexOf('design library') !== -1 || type.indexOf('designlibrary') !== -1) return true;
          const label = this.normalizeBundleFieldLabel(field.label);
          return label === 'design';
      },

      getBundleCopyTargetKeySet: function(item) {
          const set = new Set();
          (item.config || []).forEach(f => {
              if (f && f.label) set.add(this.normalizeBundleFieldLabel(f.label));
              const pk = f && this.getAiImagePhotoKeyFromField(f);
              if (pk) set.add(this.normalizeBundleFieldLabel(pk));
              const ck = f && this.getAiImageCharacterKeyFromField(f);
              if (ck) set.add(this.normalizeBundleFieldLabel(ck));
              if (this.isDesignLibraryField(f)) {
                  if (f.label) set.add(this.normalizeBundleFieldLabel(f.label));
                  set.add(this.normalizeBundleFieldLabel('Design File'));
                  set.add(this.normalizeBundleFieldLabel('Design Source'));
              }
          });
          return set;
      },

      getBundlePropRawByNormalizedKey: function(props, keyName) {
          if (!keyName) return undefined;
          const nk = this.normalizeBundleFieldLabel(keyName);
          for (const key of Object.keys(props || {})) {
              if (this.normalizeBundleFieldLabel(key) === nk) return props[key];
          }
          for (const key of Object.keys(props || {})) {
              const val = props[key];
              if (!val || typeof val !== 'object' || Array.isArray(val)) continue;
              for (const subKey of Object.keys(val)) {
                  if (this.normalizeBundleFieldLabel(subKey) === nk) return val[subKey];
              }
          }
          return undefined;
      },

      isBundlePropertyValueEmpty: function(val) {
          if (val == null || val === '') return true;
          if (Array.isArray(val) && val.length === 0) return true;
          if (typeof val === 'string' && val.trim() === '') return true;
          return false;
      },

      propertyKeysWithValues: function(props) {
          const keys = [];
          Object.keys(props || {}).forEach(key => {
              if (!this.isBundlePropertyValueEmpty(props[key])) keys.push(key);
          });
          return keys;
      },

      getBundlePropValueForFieldLabel: function(props, fieldOrLabel) {
          const field = typeof fieldOrLabel === 'string' ? { label: fieldOrLabel } : fieldOrLabel;
          if (!field || !field.label) return undefined;
          const norm = this.normalizeBundleFieldLabel(field.label);
          for (const key of Object.keys(props || {})) {
              if (this.normalizeBundleFieldLabel(key) === norm) return props[key];
          }
          const aliasMap = {
              'song topic': ['song inspiration'],
              'song inspiration': ['song topic']
          };
          const aliases = aliasMap[norm] || [];
          for (let ai = 0; ai < aliases.length; ai++) {
              const aliasNorm = aliases[ai];
              for (const key of Object.keys(props || {})) {
                  if (this.normalizeBundleFieldLabel(key) === aliasNorm) return props[key];
              }
          }
          if (field.type && String(field.type).toLowerCase().includes('ai image')) {
              const photoKey = this.getAiImagePhotoKeyFromField(field);
              if (photoKey) {
                  const pnk = this.normalizeBundleFieldLabel(photoKey);
                  for (const key of Object.keys(props || {})) {
                      if (this.normalizeBundleFieldLabel(key) === pnk) return props[key];
                  }
              }
          }
          if (this.isDesignLibraryField(field)) {
              return this.resolveDesignLibraryLabelFromProps(props, field);
          }
          return undefined;
      },

      /** Resolve design library display / validation value from Tier 1 cart props (v2 field label + legacy v1). */
      resolveDesignLibraryLabelFromProps: function(props, field) {
          if (!props || typeof props !== 'object') return undefined;
          const label = field && field.label ? String(field.label).trim() : '';
          if (label) {
              const direct = this.getBundlePropRawByNormalizedKey(props, label);
              if (!this.isBundlePropertyValueEmpty(direct)) {
                  const str = String(direct).trim();
                  if (!/^https?:\/\//i.test(str)) return str;
                  const index = (window.BUILDER_DATA && window.BUILDER_DATA.designLibraryIndex) || [];
                  for (let i = 0; i < index.length; i++) {
                      const entry = index[i];
                      if (!entry || !entry.name) continue;
                      const prev = entry.preview_image ? String(entry.preview_image) : '';
                      if (!prev) continue;
                      if (str === prev || str.indexOf(prev) !== -1 || prev.indexOf(str) !== -1) {
                          return String(entry.name).trim();
                      }
                  }
                  return str;
              }
          }
          const source = this.getBundlePropRawByNormalizedKey(props, 'Design Source');
          const file = this.getBundlePropRawByNormalizedKey(props, 'Design File');
          if (source != null && String(source).toLowerCase().indexOf('scratch') !== -1) {
              return String(source).trim() || 'Create from scratch';
          }
          if (this.isBundlePropertyValueEmpty(file)) return undefined;
          const url = String(file).trim();
          const index = (window.BUILDER_DATA && window.BUILDER_DATA.designLibraryIndex) || [];
          for (let i = 0; i < index.length; i++) {
              const entry = index[i];
              if (!entry || !entry.name) continue;
              const prev = entry.preview_image ? String(entry.preview_image) : '';
              if (!prev) continue;
              if (url === prev || url.indexOf(prev) !== -1 || prev.indexOf(url) !== -1) {
                  return String(entry.name).trim();
              }
          }
          return url;
      },

      /** Decode saved bundle slot props (PB-PROPS Tier 1) for row validation + subtitle display. */
      resolveBundleRowPropsFromSlot: function(item, slotProps) {
          if (!slotProps || typeof slotProps !== 'object') return {};
          let eff = { ...slotProps };
          if (typeof this.expandDelimiterProperties === 'function') {
              eff = this.expandDelimiterProperties({ ...slotProps });
          }
          const pb = window.productBuilder;
          if (pb && typeof pb.decodeCartLineToBuilderState === 'function' && item) {
              const decoded = pb.decodeCartLineToBuilderState(
                  { properties: slotProps },
                  item.config || [],
                  { options: item.options || [] }
              );
              if (decoded && decoded.selections && typeof decoded.selections === 'object') {
                  Object.keys(decoded.selections).forEach(function(k) {
                      if (eff[k] == null || eff[k] === '') eff[k] = decoded.selections[k];
                  });
              }
          }
          (item.config || []).forEach(function(field) {
              if (!field || !field.label) return;
              if (!this.isDesignLibraryField(field)) return;
              const display = this.resolveDesignLibraryLabelFromProps(eff, field);
              if (display != null && display !== '') eff[field.label] = display;
          }, this);
          return eff;
      },

      nestBundleSelectionsForAiImageFields: function(item, selections) {
          const out = { ...selections };
          (item.config || []).forEach(field => {
              if (!field || !field.type || String(field.type).toLowerCase().indexOf('ai image') === -1) return;
              if (!field.label) return;
              const photoKey = this.getAiImagePhotoKeyFromField(field);
              const charKey = this.getAiImageCharacterKeyFromField(field);
              const nested = {};
              if (out[field.label] && typeof out[field.label] === 'object' && !Array.isArray(out[field.label])) {
                  Object.assign(nested, out[field.label]);
              }
              if (photoKey && out[photoKey] != null && out[photoKey] !== '') {
                  nested[photoKey] = out[photoKey];
                  delete out[photoKey];
              }
              if (charKey && out[charKey] != null && out[charKey] !== '') {
                  nested[charKey] = out[charKey];
                  delete out[charKey];
              }
              if (Object.keys(nested).length) {
                  out[field.label] = nested;
              }
          });
          return out;
      },

      readScalarSelectionValue: function(val) {
          if (this.isBundlePropertyValueEmpty(val)) return undefined;
          if (typeof val === 'object') return undefined;
          return val;
      },

      isLikelyAiPhotoUrl: function(url) {
          if (typeof url !== 'string' || !url.trim()) return false;
          if (this.isLikelyAiCharacterUrl(url)) return false;
          const u = url.toLowerCase();
          if (u.indexOf('cloudinary.com') !== -1) return true;
          if (u.indexOf('/uploads/photos/') !== -1) return true;
          if (u.indexOf('/uploads/') !== -1 && u.indexOf('/generated/') === -1) return true;
          if (u.indexOf('pb-media-worker') !== -1 && u.indexOf('/media/') !== -1) return true;
          return false;
      },

      isLikelyAiCharacterUrl: function(url) {
          if (typeof url !== 'string' || !url.trim()) return false;
          const u = url.toLowerCase();
          if (u.indexOf('/uploads/') !== -1) return false;
          return u.indexOf('googleapis.com') !== -1 || u.indexOf('firebasestorage') !== -1 || u.indexOf('/generated/') !== -1 || u.indexOf('workers.dev') !== -1;
      },

      isLabelAsValueTier1Property: function(key, value) {
          const k = String(key || '').trim();
          const v = String(value == null ? '' : value).trim();
          if (!k || !v) return false;
          return k.toLowerCase() === v.toLowerCase();
      },

      isAiMediaTier1Key: function(key) {
          const k = String(key || '').trim().toLowerCase();
          if (!k) return false;
          if (k === 'photo' || k === 'character') return true;
          if (k.endsWith(' - photo') || k.endsWith(' - character')) return true;
          return false;
      },

      isDisplayableImageUrl: function(val) {
          if (typeof val !== 'string' || !val.trim()) return false;
          const u = val.trim();
          if (u.indexOf('http://') === 0 || u.indexOf('https://') === 0 || u.indexOf('//') === 0) return true;
          if (u.indexOf('/uploads/') !== -1 || u.indexOf('/generated/') !== -1) return true;
          return false;
      },

      isValidAiMediaTier1Value: function(key, value) {
          if (!this.isAiMediaTier1Key(key)) return true;
          const v = String(value == null ? '' : value).trim();
          if (!v) return false;
          if (this.isLabelAsValueTier1Property(key, value)) return false;
          return this.isDisplayableImageUrl(v);
      },

      purgeInvalidAiMediaTier1Keys: function(props) {
          const out = {};
          const self = this;
          Object.keys(props || {}).forEach(function(key) {
              const val = props[key];
              if (self.isAiMediaTier1Key(key) && !self.isValidAiMediaTier1Value(key, val)) return;
              out[key] = val;
          });
          return out;
      },

      /** Promote AI image Photo/Character URLs from nested main.selections[label] to flat keys. */
      extractAiImagePropsFromSelections: function(item, selections) {
          const out = {};
          if (!item || !selections || typeof selections !== 'object') return out;
          (item.config || []).forEach(function(field) {
              if (!field || !field.type || String(field.type).toLowerCase().indexOf('ai image') === -1) return;
              if (!field.label) return;
              const pk = this.getAiImagePhotoKeyFromField(field);
              const ck = this.getAiImageCharacterKeyFromField(field);
              const container = selections[field.label];
              const legacyPhoto = field.label + ' - Photo';
              const legacyChar = field.label + ' - Character';
              const nestedObj = (container && typeof container === 'object' && !Array.isArray(container)) ? container : null;

              const readKey = function(key, legacy) {
                  if (!key) return undefined;
                  let v;
                  if (nestedObj) {
                      v = this.readScalarSelectionValue(nestedObj[key]);
                      if (v) return v;
                      const nk = this.normalizeBundleFieldLabel(key);
                      for (const sk of Object.keys(nestedObj)) {
                          if (this.normalizeBundleFieldLabel(sk) === nk) {
                              v = this.readScalarSelectionValue(nestedObj[sk]);
                              if (v) return v;
                          }
                      }
                  }
                  v = this.readScalarSelectionValue(selections[key]);
                  if (v) return v;
                  if (legacy) {
                      v = this.readScalarSelectionValue(selections[legacy]);
                      if (v) return v;
                  }
                  return undefined;
              }.bind(this);

              let photo = readKey(pk, legacyPhoto);
              let char = readKey(ck, legacyChar);

              if (!photo) {
                  const flatPhoto = this.readScalarSelectionValue(selections.Photo);
                  if (flatPhoto) photo = flatPhoto;
              }
              if (!char) {
                  const flatChar = this.readScalarSelectionValue(selections.Character);
                  if (flatChar) char = flatChar;
              }

              if (typeof container === 'string' && container.trim()) {
                  if (this.isLikelyAiPhotoUrl(container) && !photo) photo = container.trim();
                  else if (this.isLikelyAiCharacterUrl(container) && !char) char = container.trim();
              }

              if (nestedObj) {
                  Object.keys(nestedObj).forEach(function(sk) {
                      const v = this.readScalarSelectionValue(nestedObj[sk]);
                      if (!v) return;
                      if (!char && this.isLikelyAiCharacterUrl(v)) char = v;
                      if (!photo && this.isLikelyAiPhotoUrl(v)) photo = v;
                  }, this);
              }

              if (char && this.isLikelyAiPhotoUrl(char) && !photo) {
                  photo = char;
                  char = undefined;
                  if (nestedObj) {
                      Object.keys(nestedObj).forEach(function(sk) {
                          const v = this.readScalarSelectionValue(nestedObj[sk]);
                          if (v && this.isLikelyAiCharacterUrl(v)) char = v;
                      }, this);
                  }
                  if (!char) {
                      const alt = readKey(ck, legacyChar);
                      if (alt && this.isLikelyAiCharacterUrl(alt) && alt !== photo) char = alt;
                  }
              }

              if (pk && photo && this.isValidAiMediaTier1Value(pk, photo)) out[pk] = photo;
              if (ck && char && this.isValidAiMediaTier1Value(ck, char)) out[ck] = char;
          }, this);
          return out;
      },

      /**
       * Main-flow AI draft → flat Photo / Character Tier-1 keys for bundle sync / autofill.
       * PB-FND-68: same source as finalize (aiImageByLabel + DOM via PBFlushEncode when loaded).
       */
      resolveMainAiImageTier1PropsForSync: function(item, s) {
          const out = {};
          if (!item || !s) return out;
          let byLabel = null;
          const flush = global.PBFlushEncode;
          if (flush && typeof flush.resolveMainAiImageByLabel === 'function') {
              const container = s.mode === 'SUB' ? '#sub-flow-container' : '#main-flow-container';
              const draft = flush.resolveMainAiImageByLabel(container, { builderState: s });
              if (draft && draft.byLabel) byLabel = draft.byLabel;
          }
          if (!byLabel && s.aiImageByLabel && s.aiImageByLabel.byLabel) {
              byLabel = s.aiImageByLabel.byLabel;
          }
          if (!byLabel) return out;
          (item.config || []).forEach(function(field) {
              if (!field || !field.type || String(field.type).toLowerCase().indexOf('ai image') === -1) return;
              if (!field.label) return;
              const saved = byLabel[field.label];
              if (!saved || typeof saved !== 'object') return;
              const pk = this.getAiImagePhotoKeyFromField(field);
              const ck = this.getAiImageCharacterKeyFromField(field);
              const photoUrl = saved.photoUrl && String(saved.photoUrl).trim();
              const charUrls = (saved.characterUrls || []).filter(function(u) {
                  return u != null && String(u).trim() !== '';
              });
              const pickIdx = Math.max(0, Math.min(Number(saved.selectedIndex) || 0, Math.max(charUrls.length - 1, 0)));
              const charUrl = charUrls.length ? String(charUrls[pickIdx]).trim() : '';
              if (pk && photoUrl && !this.isBundlePropertyValueEmpty(photoUrl)) out[pk] = photoUrl;
              if (ck && charUrl && !this.isBundlePropertyValueEmpty(charUrl)) out[ck] = charUrl;
          }, this);
          return out;
      },

      /** Write normalized AI image keys back to main.selections before bundle sync. */
      normalizeMainAiImageSelections: function(item) {
          const s = window.builderState;
          if (!item || !s || !s.main || !s.main.selections) return;
          const tier1Draft = this.resolveMainAiImageTier1PropsForSync(item, s);
          Object.keys(tier1Draft).forEach(function(key) {
              if (!this.isBundlePropertyValueEmpty(tier1Draft[key])) {
                  s.main.selections[key] = tier1Draft[key];
              }
          }, this);
          const aiProps = this.extractAiImagePropsFromSelections(item, s.main.selections);
          const aiFieldLabels = new Set();
          const nestedMediaKeys = new Set();
          (item.config || []).forEach(function(field) {
              if (!field || !field.type || String(field.type).toLowerCase().indexOf('ai image') === -1) return;
              if (!field.label) return;
              const pk = this.getAiImagePhotoKeyFromField(field);
              const ck = this.getAiImageCharacterKeyFromField(field);
              if (pk) nestedMediaKeys.add(pk);
              if (ck) nestedMediaKeys.add(ck);
              const nested = {};
              if (pk && aiProps[pk]) nested[pk] = aiProps[pk];
              if (ck && aiProps[ck]) nested[ck] = aiProps[ck];
              if (Object.keys(nested).length) s.main.selections[field.label] = nested;
              if (pk) delete s.main.selections[pk];
              if (ck && ck !== field.label) delete s.main.selections[ck];
              aiFieldLabels.add(field.label);
          }, this);
          Object.keys(aiProps).forEach(function(key) {
              if (aiFieldLabels.has(key)) return;
              if (nestedMediaKeys.has(key)) return;
              s.main.selections[key] = aiProps[key];
          });
      },

      flattenAiImageSelectionsForProps: function(item, selections) {
          if (!selections || typeof selections !== 'object') return {};
          const flat = { ...selections };
          const aiFlat = this.extractAiImagePropsFromSelections(item, selections);
          Object.keys(aiFlat).forEach(function(k) { flat[k] = aiFlat[k]; });
          (item.config || []).forEach(function(field) {
              if (!field || !field.label) return;
              if (field.type && String(field.type).toLowerCase().includes('ai image')) {
                  delete flat[field.label];
              }
          });
          if (typeof this.purgeInvalidAiMediaTier1Keys === 'function') {
              return this.purgeInvalidAiMediaTier1Keys(flat);
          }
          return flat;
      },

      /** Tier-1 design library props from catalogDesignLibrary via snapshot v2 encode. */
      getDesignLibraryTier1PropsFromState: function(item, s) {
          const state = s || window.builderState || {};
          const selections = (state.main && state.main.selections) || {};
          const fieldConfig = (item && item.config) || [];
          if (typeof this.encodeDesignLibraryPropsFromState === 'function') {
              const encoded = this.encodeDesignLibraryPropsFromState(
                  {
                      catalogDesignLibrary: state.catalogDesignLibrary,
                      selections: selections,
                  },
                  fieldConfig
              );
              if (encoded && Object.keys(encoded).length) return encoded;
          }
          if (typeof this.catalogDesignLibraryToTier1Props === 'function') {
              const encoded = this.catalogDesignLibraryToTier1Props(state.catalogDesignLibrary, selections);
              if (encoded && Object.keys(encoded).length) return encoded;
          }
          return {};
      },

      getEffectiveBundleRowProperties: function(bundleId, idx, item, firstMainIdx, mainProduct, s) {
          const sameId = (a, b) => String(a && a.id) === String(b && b.id);
          const slot = s.bundle.configurations[bundleId] && s.bundle.configurations[bundleId][idx];
          let slotProps = (slot && slot.properties) ? { ...slot.properties } : {};
          if (idx === firstMainIdx && sameId(item, mainProduct)) {
              const rawMain = s.main.selections || {};
              const flatSelections = this.flattenAiImageSelectionsForProps(item, rawMain);
              const mainProps = this.buildBundleEffectiveMainProps(flatSelections, s.main.options);
              const aiProps = this.extractAiImagePropsFromSelections(item, rawMain);
              const mainAiDraft = this.resolveMainAiImageTier1PropsForSync(item, s);
              const mainOwnsDl =
                  typeof window !== 'undefined' &&
                  window.PBBundleRowEncode &&
                  typeof window.PBBundleRowEncode.mainOwnsDesignLibraryPick === 'function'
                      ? window.PBBundleRowEncode.mainOwnsDesignLibraryPick(s)
                      : true;
              const designProps = mainOwnsDl ? this.getDesignLibraryTier1PropsFromState(item, s) : {};
              const merged = { ...mainProps, ...designProps, ...slotProps };
              Object.keys(aiProps).forEach(function(k) {
                  if (!this.isBundlePropertyValueEmpty(aiProps[k])) merged[k] = aiProps[k];
              }, this);
              Object.keys(mainAiDraft).forEach(function(k) {
                  if (!this.isBundlePropertyValueEmpty(mainAiDraft[k])) merged[k] = mainAiDraft[k];
              }, this);
              if (slotProps && Object.keys(slotProps).length) {
                  const decodedSlot = this.resolveBundleRowPropsFromSlot(item, slotProps);
                  Object.keys(decodedSlot).forEach(function(k) {
                      if (!this.isBundlePropertyValueEmpty(decodedSlot[k])) merged[k] = decodedSlot[k];
                  }, this);
              }
              return window.PBBundleRowEncode?.applyMainAiTextProps
                  ? window.PBBundleRowEncode.applyMainAiTextProps(merged, item, s)
                  : merged;
          }
          if (slotProps && Object.keys(slotProps).length) {
              return this.resolveBundleRowPropsFromSlot(item, slotProps);
          }
          return slotProps;
      },

      /** One display brain — design catalog + attached AI/photo via shared resolver. */
      resolveAttachedDisplayImageUrl: function(props, fallbackImage, fieldConfig) {
          const DL = global.PBDesignLibraryLogic;
          if (DL && typeof DL.resolveDesignDisplayImage === 'function') {
              const result = DL.resolveDesignDisplayImage(
                  { properties: props, fallbackImage: fallbackImage || '' },
                  { fieldConfig: fieldConfig || null }
              );
              if (result && result.url) return result.url;
          }
          const cart = global.PBCartDisplayImage;
          if (cart && typeof cart.resolveCartLineDisplayImageUrl === 'function') {
              return cart.resolveCartLineDisplayImageUrl(props, {
                  fallbackImage: fallbackImage || '',
                  fieldConfig: fieldConfig || null
              });
          }
          return fallbackImage || '';
      },

      resolveDesignDisplayImageUrl: function(propsOrSelections, fallbackImage, fieldConfig) {
          return this.resolveAttachedDisplayImageUrl(propsOrSelections, fallbackImage, fieldConfig);
      },

      resolveBundleRowDisplayImageUrl: function(bundleId, idx, item, bundle, mainProduct, s) {
          const sameId = (a, b) => String(a && a.id) === String(b && b.id);
          const firstMainIdx = bundle && bundle.items
              ? bundle.items.findIndex(i => sameId(i, mainProduct))
              : -1;
          const props = this.getEffectiveBundleRowProperties(bundleId, idx, item, firstMainIdx, mainProduct, s);
          const fallback = item && item.image ? item.image : '';
          const fieldConfig = this.getBundleRowValidationFields(bundleId, idx, item, bundle, mainProduct, s);
          return this.resolveAttachedDisplayImageUrl(props, fallback, fieldConfig);
      },

      /** True when the bundle row needs Personalize / Edit (personalization fields and/or variant pick). */
      bundleRowNeedsConfiguration: function(item) {
          if (!item) return false;
          const hasPersonalizationFields = item.config && item.config.length > 0;
          const personalizationRequired = !item.skipPersonalizationInBundle && hasPersonalizationFields;
          return personalizationRequired || !item.isSimple;
      },

      /** Decoded effective props + validation fields for a bundle row (shared by readiness + subtitle). */
      getBundleRowReadinessInputs: function(bundleId, bundle, idx, mainProduct, s) {
          const bid = bundleId != null && bundleId !== '' ? String(bundleId) : '';
          const item = bundle && bundle.items ? bundle.items[idx] : null;
          const sameId = (a, b) => String(a && a.id) === String(b && b.id);
          const firstMainIdx = bundle && bundle.items
              ? bundle.items.findIndex(i => sameId(i, mainProduct))
              : -1;
          let effectiveProps = item
              ? this.getEffectiveBundleRowProperties(bid, idx, item, firstMainIdx, mainProduct, s)
              : {};
          if (this.expandDelimiterProperties) {
              effectiveProps = this.expandDelimiterProperties({ ...effectiveProps });
          }
          const validationFields = item && typeof this.getBundleRowValidationFields === 'function'
              ? this.getBundleRowValidationFields(bid, idx, item, bundle, mainProduct, s)
              : ((item && item.config) || []);
          return { bid, item, firstMainIdx, effectiveProps, validationFields };
      },

      /** Row-scoped aiImage.byLabel for async finalizeReady checks (PB-AI-5). */
      resolveBundleRowAiImageByLabelForReadiness: function(bundleId, bundle, idx, mainProduct, s) {
          const inputs = this.getBundleRowReadinessInputs(bundleId, bundle, idx, mainProduct, s);
          const item = inputs.item;
          const bid = inputs.bid;
          if (!item) return {};

          const sameId = (a, b) => String(a && a.id) === String(b && b.id);
          const isAnchor = idx === inputs.firstMainIdx && sameId(item, mainProduct);
          const editingRow =
              s &&
              s.mode === 'SUB' &&
              s.sub &&
              s.sub.isQueueItem &&
              String(s.sub.currentId) === String(idx);

          if (
              typeof window !== 'undefined' &&
              window.PBBundleRowEncode &&
              typeof window.PBBundleRowEncode.resolveRowAiImageByLabel === 'function'
          ) {
              const rowAiImageByLabel =
                  editingRow && s.sub.aiImageByLabel
                      ? s.sub.aiImageByLabel
                      : isAnchor && s.aiImageByLabel
                        ? s.aiImageByLabel
                        : undefined;
              const resolved = window.PBBundleRowEncode.resolveRowAiImageByLabel(
                  inputs.effectiveProps,
                  item,
                  this,
                  {
                      rowAiImageByLabel: rowAiImageByLabel,
                      collectFromDom: !!(editingRow || isAnchor),
                      containerSelector: editingRow ? '#sub-flow-container' : '#main-flow-container',
                  }
              );
              if (resolved && resolved.byLabel) return resolved.byLabel;
          }

          const byLabel = {};
          if (typeof this.aiImageFromSyncedProps === 'function') {
              const fromProps = this.aiImageFromSyncedProps(inputs.effectiveProps, item);
              if (fromProps && fromProps.byLabel) Object.assign(byLabel, fromProps.byLabel);
          }
          return byLabel;
      },

      /** Required AI fields not finalizeReady — consumed by offer-line resolver (PB-AI-5). */
      computeBundleRowAiFinalizeGaps: function(bundleId, bundle, idx, mainProduct, s) {
          const inputs = this.getBundleRowReadinessInputs(bundleId, bundle, idx, mainProduct, s);
          const api = typeof window !== 'undefined' ? window.PBFieldAiImage : null;
          if (!api || typeof api.computeBundleRowAiFinalizeGaps !== 'function') return [];

          const byLabel = this.resolveBundleRowAiImageByLabelForReadiness(bundleId, bundle, idx, mainProduct, s);
          const pb = this;
          return api.computeBundleRowAiFinalizeGaps(inputs.validationFields, byLabel, {
              isFieldRequired: function(field) {
                  return pb.isBundleFieldRequired(field);
              },
              reviewAcknowledgedForField: function(label) {
                  if (
                      typeof window !== 'undefined' &&
                      window.PBAiReviewHop &&
                      typeof window.PBAiReviewHop.isReviewAcknowledged === 'function'
                  ) {
                      return window.PBAiReviewHop.isReviewAcknowledged(s, label);
                  }
                  return false;
              },
          });
      },

      /** Single source of truth — Edit/Personalize, Continue, subtitle gate. */
      resolveBundleRowReadinessForRow: function(bundleId, bundle, idx, mainProduct, s) {
          const inputs = this.getBundleRowReadinessInputs(bundleId, bundle, idx, mainProduct, s);
          const item = inputs.item;
          const bid = inputs.bid;
          const slot = bid && s.bundle.configurations[bid] && s.bundle.configurations[bid][idx];
          const pb = this;
          const fallback = {
              displayConfigured: false,
              checkoutReady: false,
              showSubtitle: false,
              missingLabels: ['__resolver_missing__'],
              autoSyncedReady: false
          };
          if (!item) return fallback;

          const R = window.PBOfferLineResolver;
          if (!R || typeof R.resolveBundleRowReadiness !== 'function') {
              fallback.displayConfigured = this._isBundleRowCompleteInner
                  ? this._isBundleRowCompleteInner(bundleId, bundle, idx, mainProduct, s)
                  : false;
              fallback.checkoutReady = fallback.displayConfigured;
              fallback.showSubtitle = !!(slot && slot.properties && Object.keys(slot.properties).length);
              return fallback;
          }

          return R.resolveBundleRowReadiness({
              item: item,
              slot: slot,
              userEdited: typeof this.isBundleRowUserEdited === 'function' && this.isBundleRowUserEdited(bid, idx, s),
              needsConfiguration: this.bundleRowNeedsConfiguration(item),
              effectiveProps: inputs.effectiveProps,
              validationFields: inputs.validationFields,
              hasResolvedVariant: typeof this.bundleRowHasResolvedVariantId === 'function'
                  && this.bundleRowHasResolvedVariantId(bid, idx, item, mainProduct, s),
              anchorComplete: this.isMainAnchorRowCompleteFromMainFlow(bid, bundle, idx, item, mainProduct, s),
              getMissingStrictLabels: function() {
                  return pb.computeBundleRowMissingFieldLabels(bundleId, bundle, idx, mainProduct, s);
              },
              isFieldRequired: function(field) {
                  return pb.isBundleFieldRequired(field);
              },
              omitMediaField: function(field) {
                  return typeof pb.shouldOmitFieldTypeForSubtitle === 'function'
                      && pb.shouldOmitFieldTypeForSubtitle(field);
              },
              getPropValueForField: function(props, field) {
                  return pb.getBundlePropValueForFieldLabel(props, field);
              },
              isPropertyEmpty: function(val) {
                  return pb.isBundlePropertyValueEmpty(val);
              },
              getAiFinalizeGaps: function() {
                  return pb.computeBundleRowAiFinalizeGaps(bundleId, bundle, idx, mainProduct, s);
              }
          });
      },

      isBundleRowComplete: function(bundleId, bundle, idx, mainProduct, s) {
          return this.resolveBundleRowReadinessForRow(bundleId, bundle, idx, mainProduct, s).displayConfigured;
      },

      isBundleRowDisplayConfigured: function(bundleId, bundle, idx, mainProduct, s) {
          return this.resolveBundleRowReadinessForRow(bundleId, bundle, idx, mainProduct, s).displayConfigured;
      },

      isBundleRowAutoSyncedReady: function(bundleId, bundle, idx, mainProduct, s) {
          return this.resolveBundleRowReadinessForRow(bundleId, bundle, idx, mainProduct, s).autoSyncedReady;
      },

      /** Continue / checkout gate — uses unified readiness resolver. */
      isBundleRowCheckoutReady: function(bundleId, bundle, idx, mainProduct, s) {
          const item = bundle && bundle.items ? bundle.items[idx] : null;
          if (!item || !this.bundleRowNeedsConfiguration(item)) return true;
          return this.resolveBundleRowReadinessForRow(bundleId, bundle, idx, mainProduct, s).checkoutReady;
      },

      /** Unified Edit vs Personalize — delegates to readiness resolver. */
      isOfferLineConfigured: function(bundleId, bundle, idx, item, mainProduct, s) {
          if (bundle && typeof idx === 'number' && typeof this.resolveBundleRowReadinessForRow === 'function') {
              return this.resolveBundleRowReadinessForRow(bundleId, bundle, idx, mainProduct, s).displayConfigured;
          }
          const pb = this;
          const bid = bundleId != null && bundleId !== '' ? String(bundleId) : '';
          const slot = bid && s.bundle.configurations[bid] && s.bundle.configurations[bid][idx];
          const sameId = (a, b) => String(a && a.id) === String(b && b.id);
          const firstMainIdx = bundle && bundle.items
              ? bundle.items.findIndex(i => sameId(i, mainProduct))
              : -1;
          const R = window.PBOfferLineResolver;
          if (R && typeof R.isOfferLineConfigured === 'function') {
              return R.isOfferLineConfigured({
                  bundleId: bid,
                  idx: idx,
                  firstMainIdx: firstMainIdx,
                  item: item,
                  bundle: bundle,
                  mainProduct: mainProduct,
                  state: s,
                  slot: slot,
                  bundleRowNeedsConfiguration: function() { return pb.bundleRowNeedsConfiguration(item); },
                  getMissingFieldLabels: function() {
                      return pb.getBundleRowMissingFieldLabels(bid, bundle, idx, mainProduct, s);
                  },
                  resolveVariantId: function(it, sel) {
                      return typeof pb.resolveBundleItemVariantId === 'function'
                          ? pb.resolveBundleItemVariantId(it, sel)
                          : null;
                  },
                  isStrictBundleRowComplete: function() {
                      return pb.getBundleRowMissingFieldLabels(bid, bundle, idx, mainProduct, s).length === 0;
                  }
              });
          }
          if (item && this.isMainAnchorRowCompleteFromMainFlow(bid, bundle, idx, item, mainProduct, s)) return true;
          return this.getBundleRowMissingFieldLabels(bid, bundle, idx, mainProduct, s).length === 0;
      },

      /** Readiness signature so row button state cannot stay stale when sync fills slots. */
      buildOffersReadinessSignature: function() {
          const data = window.BUILDER_DATA;
          const s = window.builderState;
          const mainProduct = data && data.mainProduct;
          if (!mainProduct || !s) return '';
          const parts = [];
          const pb = this;
          const host = typeof pb.getMainProductHost === 'function'
              ? pb.getMainProductHost(mainProduct, s)
              : mainProduct;
          const singleBundle = { items: [host] };
          if (typeof pb.resolveBundleRowReadinessForRow === 'function') {
              const solo = pb.resolveBundleRowReadinessForRow('', singleBundle, 0, mainProduct, s);
              parts.push('solo:' + (solo.displayConfigured ? 1 : 0) + (solo.checkoutReady ? 1 : 0));
          }
          (data.bundles || []).forEach(function(b) {
              if (!b || !b.items) return;
              b.items.forEach(function(_item, idx) {
                  if (!pb.resolveBundleRowReadinessForRow) return;
                  const r = pb.resolveBundleRowReadinessForRow(b.id, b, idx, mainProduct, s);
                  parts.push(String(b.id) + ':' + idx + ':' + (r.displayConfigured ? 1 : 0) + (r.checkoutReady ? 1 : 0));
              });
          });
          return parts.join('|');
      },

      /** Same PDP product at the first matching bundle index, no saved slot — mirror Single-row completion. */
      isMainAnchorRowEligibleForPdpCompletion: function(bundleId, idx, item, bundle, mainProduct, s) {
          if (!item || !mainProduct || !s || !bundle || !Array.isArray(bundle.items)) return false;
          const slot = s.bundle.configurations[bundleId] && s.bundle.configurations[bundleId][idx];
          if (slot && slot.properties && Object.keys(slot.properties).length) {
              const R = window.PBOfferLineResolver;
              const missingFn = function() {
                  return this.computeBundleRowMissingFieldLabels(bundleId, bundle, idx, mainProduct, s);
              }.bind(this);
              if (R && typeof R.isCompleteSlotOverride === 'function' && R.isCompleteSlotOverride(slot, missingFn)) {
                  return false;
              }
          }
          const sameId = (a, b) => String(a && a.id) === String(b && b.id);
          const firstMainIdx = bundle.items.findIndex(i => sameId(i, mainProduct));
          return idx === firstMainIdx && sameId(item, mainProduct);
      },

      isMainAnchorRowCompleteFromMainFlow: function(bundleId, bundle, idx, item, mainProduct, s) {
          if (!this.bundleRowNeedsConfiguration(item)) return true;
          if (!this.isMainAnchorRowEligibleForPdpCompletion(bundleId, idx, item, bundle, mainProduct, s)) return false;
          if (!this.isStandaloneMainFlowComplete(mainProduct, s)) return false;
          if (!item.isSimple && !this.bundleRowHasResolvedVariantId(bundleId, idx, item, mainProduct, s)) return false;
          return true;
      },

      /** @deprecated Use isMainAnchorRowCompleteFromMainFlow — PDP-only name removed PB-FND-69 */
      isMainAnchorRowCompleteFromPdp: function(bundleId, bundle, idx, item, mainProduct, s) {
          return this.isMainAnchorRowCompleteFromMainFlow(bundleId, bundle, idx, item, mainProduct, s);
      },

      bundleRowHasResolvedVariantId: function(bundleId, idx, item, mainProduct, s) {
          const slot = s.bundle.configurations[bundleId] && s.bundle.configurations[bundleId][idx];
          if (slot && slot.id) return true;
          const sameId = (a, b) => String(a && a.id) === String(b && b.id);
          if (!sameId(item, mainProduct) || !s.main || !s.main.selections) return false;
          if (typeof this.resolveBundleItemVariantId !== 'function') return false;
          const bundle = (window.BUILDER_DATA && window.BUILDER_DATA.bundles || []).find(function(b) {
              return String(b && b.id) === String(bundleId);
          });
          const firstMainIdx = bundle && bundle.items
              ? bundle.items.findIndex(i => sameId(i, mainProduct))
              : 0;
          /* Main-flow variant credit applies only to the anchor row, not duplicate same-SKU lines. */
          if (typeof idx === 'number' && idx !== firstMainIdx) return false;
          return !!this.resolveBundleItemVariantId(item, s.main.selections);
      },

      /** Config fields used to validate/display a bundle row (PDP anchor without slot uses main product config). */
      getBundleRowValidationFields: function(bundleId, idx, item, bundle, mainProduct, s) {
          const fields = (item && item.config) ? item.config : [];
          if (!bundle || !mainProduct || !item) return fields;
          const sameId = (a, b) => String(a && a.id) === String(b && b.id);
          const firstMainIdx = bundle.items.findIndex(i => sameId(i, mainProduct));
          if (idx !== firstMainIdx || !sameId(item, mainProduct)) return fields;
          const slot = s.bundle.configurations[bundleId] && s.bundle.configurations[bundleId][idx];
          if (slot && slot.properties && Object.keys(slot.properties).length) return fields;
          if (mainProduct.config && mainProduct.config.length) return mainProduct.config;
          return fields;
      },

      /** Persist main-flow personalization onto the matching bundle anchor row when complete. */
      seedAnchorBundleRowFromMain: function(bundleId, bundle, mainProduct, s) {
          const api = window.PBOfferBundleSync;
          if (api && typeof api.seedAnchorRowFromMainFlow === 'function') {
              const pb = this;
              return api.seedAnchorRowFromMainFlow({
                  bundleId: bundleId,
                  bundle: bundle,
                  mainProduct: mainProduct,
                  state: s,
                  isAnchorRowComplete: function(bid, b, idx, mp, st) {
                      const item = b && b.items ? b.items[idx] : null;
                      return pb.isMainAnchorRowCompleteFromMainFlow(bid, b, idx, item, mp, st);
                  },
                  getEffectiveProps: function(bid, idx, item, firstMainIdx, mp, st) {
                      return pb.getEffectiveBundleRowProperties(bid, idx, item, firstMainIdx, mp, st);
                  },
                  resolveVariantId: function(item, sel) {
                      return typeof pb.resolveBundleItemVariantId === 'function'
                          ? pb.resolveBundleItemVariantId(item, sel)
                          : null;
                  },
                  buildSlotProperties: function(props, bundleItem) {
                      const expanded = pb.expandDelimiterProperties
                          ? pb.expandDelimiterProperties({ ...props })
                          : { ...props };
                      if (typeof pb.buildSyncedBundleRowProperties === 'function') {
                          return pb.buildSyncedBundleRowProperties(bundleItem, expanded);
                      }
                      throw new Error('Personalization could not be saved. Please refresh the page and try again.');
                  }
              });
          }
          const bid = bundleId != null && bundleId !== '' ? String(bundleId) : '';
          if (!bid || !bundle || !mainProduct || !s) return false;
          const sameId = (a, b) => String(a && a.id) === String(b && b.id);
          const idx = bundle.items.findIndex(i => sameId(i, mainProduct));
          if (idx < 0) return false;
          const item = bundle.items[idx];
          if (!item) return false;
          if (!s.bundle.configurations[bid]) s.bundle.configurations[bid] = {};
          const existing = s.bundle.configurations[bid][idx];
          if (existing && existing.properties && Object.keys(existing.properties).length) return false;
          if (!this.isMainAnchorRowCompleteFromMainFlow(bid, bundle, idx, item, mainProduct, s)) {
              return false;
          }
          const firstMainIdx = idx;
          let props = this.getEffectiveBundleRowProperties(bid, idx, item, firstMainIdx, mainProduct, s);
          if (typeof this.buildSyncedBundleRowProperties === 'function') {
              props = this.buildSyncedBundleRowProperties(item, props);
          } else {
              throw new Error('Personalization could not be saved. Please refresh the page and try again.');
          }
          const variantId = typeof this.resolveBundleItemVariantId === 'function'
              ? this.resolveBundleItemVariantId(item, s.main.selections || {})
              : null;
          if (!variantId) return false;
          s.bundle.configurations[bid][idx] = { id: variantId, properties: props };
          return true;
      },

      computeBundleRowMissingFieldLabels: function(bundleId, bundle, idx, mainProduct, s) {
          const missing = [];
          const item = bundle.items[idx];
          if (!item) return ['__no_item__'];
          const sameId = (a, b) => String(a && a.id) === String(b && b.id);
          const firstMainIdx = bundle.items.findIndex(i => sameId(i, mainProduct));
          if (!this.bundleRowNeedsConfiguration(item)) return [];
          let eff = this.getEffectiveBundleRowProperties(bundleId, idx, item, firstMainIdx, mainProduct, s);
          if (this.expandBundleSyncSourceProps) {
              eff = this.expandBundleSyncSourceProps(eff);
          } else if (this.expandDelimiterProperties) {
              eff = this.expandDelimiterProperties({ ...eff });
          }
          if (item.skipPersonalizationInBundle) {
              const slot = s.bundle.configurations[bundleId] && s.bundle.configurations[bundleId][idx];
              if (!item.isSimple && !(slot && slot.id)) missing.push('__variant_id__');
              else if (!slot) missing.push('__slot__');
              return missing;
          }
          if (idx === firstMainIdx && sameId(item, mainProduct)) {
              const slot = s.bundle.configurations[bundleId] && s.bundle.configurations[bundleId][idx];
              if (!(slot && slot.properties && Object.keys(slot.properties).length)) {
                  const mainKeys = Object.keys(s.main.selections || {});
                  if (mainKeys.length === 0) {
                      missing.push('__main_selections__');
                      return missing;
                  }
              }
          }
          if (item.config && item.config.length > 0) {
              const validationFields = this.getBundleRowValidationFields(bundleId, idx, item, bundle, mainProduct, s);
              for (let fi = 0; fi < validationFields.length; fi++) {
                  const field = validationFields[fi];
                  if (!this.isBundleFieldRequired(field)) continue;
                  if (field.type && String(field.type).toLowerCase().includes('ai image')) {
                      const pk = this.getAiImagePhotoKeyFromField(field);
                      const ck = this.getAiImageCharacterKeyFromField(field);
                      const pv = pk ? this.getBundlePropRawByNormalizedKey(eff, pk) : undefined;
                      const cv = ck ? this.getBundlePropRawByNormalizedKey(eff, ck) : undefined;
                      if (this.isBundlePropertyValueEmpty(pv)) missing.push((field.label || pk || 'ai_photo') + ':photo');
                      if (this.isBundlePropertyValueEmpty(cv)) missing.push((field.label || ck || 'ai_character') + ':character');
                  } else if (this.isDesignLibraryField(field)) {
                      const v = this.resolveDesignLibraryLabelFromProps(eff, field);
                      if (this.isBundlePropertyValueEmpty(v)) missing.push(field.label || 'Design');
                  } else {
                      const v = this.getBundlePropValueForFieldLabel(eff, field);
                      if (this.isBundlePropertyValueEmpty(v)) missing.push(field.label || ('field_' + fi));
                  }
              }
              if (!item.isSimple) {
                  if (!this.bundleRowHasResolvedVariantId(bundleId, idx, item, mainProduct, s)) missing.push('__variant_id__');
              }
              return missing;
          }
          if (!item.isSimple) {
              if (!this.bundleRowHasResolvedVariantId(bundleId, idx, item, mainProduct, s)) missing.push('__variant_id__');
          } else if (!s.bundle.configurations[bundleId] || !s.bundle.configurations[bundleId][idx]) missing.push('__slot__');
          return missing;
      },

      getBundleRowMissingFieldLabels: function(bundleId, bundle, idx, mainProduct, s) {
          const item = bundle && bundle.items ? bundle.items[idx] : null;
          if (item && this.isMainAnchorRowCompleteFromMainFlow(bundleId, bundle, idx, item, mainProduct, s)) return [];
          return this.computeBundleRowMissingFieldLabels(bundleId, bundle, idx, mainProduct, s);
      },

      _isBundleRowCompleteInner: function(bundleId, bundle, idx, mainProduct, s) {
          const item = bundle.items[idx];
          if (!item) return false;
          const sameId = (a, b) => String(a && a.id) === String(b && b.id);
          const firstMainIdx = bundle.items.findIndex(i => sameId(i, mainProduct));
          if (!this.bundleRowNeedsConfiguration(item)) return true;
          let eff = this.getEffectiveBundleRowProperties(bundleId, idx, item, firstMainIdx, mainProduct, s);
          if (this.expandDelimiterProperties) {
              eff = this.expandDelimiterProperties({ ...eff });
          }
          if (item.skipPersonalizationInBundle) {
              const slot = s.bundle.configurations[bundleId] && s.bundle.configurations[bundleId][idx];
              if (!item.isSimple) return !!(slot && slot.id);
              return !!slot;
          }
          if (idx === firstMainIdx && sameId(item, mainProduct)) {
              const slot = s.bundle.configurations[bundleId] && s.bundle.configurations[bundleId][idx];
              if (!(slot && slot.properties && Object.keys(slot.properties).length)) {
                  const mainKeys = Object.keys(s.main.selections || {});
                  if (mainKeys.length === 0) return false;
              }
          }
          if (item.config && item.config.length > 0) {
              for (let fi = 0; fi < item.config.length; fi++) {
                  const field = item.config[fi];
                  if (!this.isBundleFieldRequired(field)) continue;
                  if (field.type && String(field.type).toLowerCase().includes('ai image')) {
                      const pk = this.getAiImagePhotoKeyFromField(field);
                      const ck = this.getAiImageCharacterKeyFromField(field);
                      const pv = pk ? this.getBundlePropRawByNormalizedKey(eff, pk) : undefined;
                      const cv = ck ? this.getBundlePropRawByNormalizedKey(eff, ck) : undefined;
                      if (this.isBundlePropertyValueEmpty(pv) || this.isBundlePropertyValueEmpty(cv)) return false;
                  } else if (this.isDesignLibraryField(field)) {
                      const v = this.resolveDesignLibraryLabelFromProps(eff, field);
                      if (this.isBundlePropertyValueEmpty(v)) return false;
                  } else {
                      const v = this.getBundlePropValueForFieldLabel(eff, field);
                      if (this.isBundlePropertyValueEmpty(v)) return false;
                  }
              }
              if (!item.isSimple) {
                  const slot = s.bundle.configurations[bundleId] && s.bundle.configurations[bundleId][idx];
                  if (!slot || !slot.id) return false;
              }
              return true;
          }
          const slot = s.bundle.configurations[bundleId] && s.bundle.configurations[bundleId][idx];
          if (!item.isSimple) return !!(slot && slot.id);
          return !!slot;
      },

      resolveBundleSourceIndex: function(bundle, mainProduct, s) {
          const sameId = (a, b) => String(a && a.id) === String(b && b.id);
          const pdpIdx = bundle.items.findIndex(item => sameId(item, mainProduct));
          if (pdpIdx >= 0 && this.isBundleRowComplete(bundle.id, bundle, pdpIdx, mainProduct, s)) return pdpIdx;
          for (let i = 0; i < bundle.items.length; i++) {
              if (this.isBundleRowComplete(bundle.id, bundle, i, mainProduct, s)) return i;
          }
          return -1;
      },

      /** Best row to copy from — strict-complete first, then PDP main selections, then any saved slot with overlap. */
      resolveBundleSyncSourceIndex: function(bundle, mainProduct, s) {
          const strict = this.resolveBundleSourceIndex(bundle, mainProduct, s);
          if (strict >= 0) return strict;

          const bid = bundle.id;
          const sameId = (a, b) => String(a && a.id) === String(b && b.id);
          const firstMainIdx = bundle.items.findIndex(i => sameId(i, mainProduct));

          const hasSyncableTarget = function(sourceIdx, sourceItem, sourceProps) {
              for (let t = 0; t < bundle.items.length; t++) {
                  if (t === sourceIdx) continue;
                  const targetItem = bundle.items[t];
                  if (targetItem.skipPersonalizationInBundle && targetItem.isSimple) continue;
                  if (!this.canSyncBundleLine(sourceItem, targetItem)) continue;
                  if (this.hasBundleLabelOverlap(sourceProps, targetItem)) return true;
              }
              return false;
          }.bind(this);

          if (firstMainIdx >= 0) {
              const sourceItem = bundle.items[firstMainIdx];
              const sourceProps = this.getEffectiveBundleRowProperties(bid, firstMainIdx, sourceItem, firstMainIdx, mainProduct, s);
              const sourceEff = this.expandBundleSyncSourceProps ? this.expandBundleSyncSourceProps(sourceProps) : sourceProps;
              if (this.propertyKeysWithValues(sourceEff).length > 0 && hasSyncableTarget(firstMainIdx, sourceItem, sourceProps)) {
                  return firstMainIdx;
              }
          }

          for (let i = 0; i < bundle.items.length; i++) {
              const slot = s.bundle.configurations[bid] && s.bundle.configurations[bid][i];
              if (!(slot && slot.properties && Object.keys(slot.properties).length)) continue;
              const sourceItem = bundle.items[i];
              const sourceProps = this.getEffectiveBundleRowProperties(bid, i, sourceItem, firstMainIdx, mainProduct, s);
              const sourceEff = this.expandBundleSyncSourceProps ? this.expandBundleSyncSourceProps(sourceProps) : sourceProps;
              if (this.propertyKeysWithValues(sourceEff).length === 0) continue;
              if (hasSyncableTarget(i, sourceItem, sourceProps)) return i;
          }

          return -1;
      },

      /** Expand serialized line-item props (numbered / hidden JSON keys) before sync overlap + copy. */
      expandBundleSyncSourceProps: function(props) {
          if (!props || typeof props !== 'object') return {};
          let eff = this.expandDelimiterProperties
              ? this.expandDelimiterProperties({ ...props })
              : { ...props };
          Object.keys({ ...eff }).forEach(function(key) {
              const val = eff[key];
              if (!val || typeof val !== 'object' || Array.isArray(val)) return;
              Object.keys(val).forEach(function(subKey) {
                  if (eff[subKey] == null || eff[subKey] === '') eff[subKey] = val[subKey];
              });
          });
          return eff;
      },

      hasBundleLabelOverlap: function(sourceProps, targetItem) {
          if (targetItem && targetItem.skipPersonalizationInBundle) return false;
          const eff = this.expandBundleSyncSourceProps(sourceProps);
          const targetKeys = this.getBundleCopyTargetKeySet(targetItem);
          if (!targetKeys.size) return false;

          for (let fi = 0; fi < (targetItem.config || []).length; fi++) {
              const field = targetItem.config[fi];
              if (!field) continue;
              if (field.type && String(field.type).toLowerCase().includes('ai image')) {
                  const pk = this.getAiImagePhotoKeyFromField(field);
                  const ck = this.getAiImageCharacterKeyFromField(field);
                  const pv = pk ? this.getBundlePropRawByNormalizedKey(eff, pk) : undefined;
                  const cv = ck ? this.getBundlePropRawByNormalizedKey(eff, ck) : undefined;
                  if (!this.isBundlePropertyValueEmpty(pv) || !this.isBundlePropertyValueEmpty(cv)) return true;
              } else if (this.isDesignLibraryField(field)) {
                  const v = this.resolveDesignLibraryLabelFromProps(eff, field);
                  if (!this.isBundlePropertyValueEmpty(v)) return true;
              } else {
                  const v = this.getBundlePropValueForFieldLabel(eff, field);
                  if (!this.isBundlePropertyValueEmpty(v)) return true;
              }
          }

          const srcNorm = new Set(this.propertyKeysWithValues(eff).map(k => this.normalizeBundleFieldLabel(k)));
          for (const tk of targetKeys) {
              if (srcNorm.has(tk)) return true;
          }
          return false;
      },
    });
    global.PBBundleRowValidation = { patched: true };
  }

  global.PBBundleRowValidationPatch = patchProductBuilder;

  if (global.document && global.document.readyState === 'loading') {
    global.document.addEventListener('DOMContentLoaded', patchProductBuilder, { once: true });
  } else {
    patchProductBuilder();
  }

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { patchProductBuilder: patchProductBuilder };
  }
})(typeof window !== 'undefined' ? window : globalThis);
